
import { createContext } from 'react';

const LandingPageContext = createContext();

export default LandingPageContext;
